import React from 'react';
import * as styles from './detailedCurriculum.module.scss';

const ROWS = [
  { block: 'Sprint 1', module: 'Foundations & the AI-App Mindset', when: 'Weeks 1–4', builds: 'PromptForge · ModelSwitch · SnapClassify', themes: 'LLM Foundations · Prompt Engineering · Context Engineering · Structured Outputs' },
  { block: 'Sprint 2', module: 'Grounding with Data — RAG', when: 'Weeks 5–8', builds: 'FindIt · AskDocs', themes: 'Embeddings · Chunking · Hybrid Search · Re-ranking' },
  { block: 'Sprint 3', module: 'Agents, Protocols, MCP & Enterprise Integration', when: 'Weeks 9–12', builds: 'ToolAgent · GateKeeper MCP · TriageOps', themes: 'Agent Loop · Tool Calling · MCP · RBAC & Audit' },
  { block: 'Sprint 4', module: 'Eval-Driven Development, Fine-Tuning & Coding Agents I', when: 'Weeks 13–16', builds: 'EvalLab · TinyTune · DomainCopilot', themes: 'LLM-as-Judge · Deploy Gates · LoRA / QLoRA · DPO' },
  { block: 'Sprint 5', module: 'Production, Cloud, Compliance & Real-Time', when: 'Weeks 17–20', builds: 'RouteCache · SafeOps · VoiceMate · ShipIt', themes: 'Observability · Drift & Incidents · Cost & Latency · Caching' },
  { block: 'Sprint 6', module: 'Coding Agents II–III, Problem → Production & Capstone', when: 'Weeks 21–24', builds: 'RepoAgent · Capstone', themes: 'Coding Agents · md-files & Hooks · Agentic Review · Spec & Metrics' },
  { block: 'Interview sprint', module: 'Interview Preparation Sprint', when: 'Weeks 25–26', builds: 'Practice rounds · portfolio walkthrough', themes: 'System design · Decomposition · Behavioural · Portfolio', highlight: true },
  { block: 'Optional', module: 'Data Structures & Algorithms', when: 'Self-paced', builds: '—', themes: '300+ problems on the platform with guided session recordings' },
  { block: 'Optional', module: 'System Design', when: 'Self-paced', builds: '—', themes: 'Low-level and high-level design with hands-on scenarios' },
];

const Outline = () => {
  return (
    <section id="outline">
      <div className={styles.wrap}>
        <h2 className={styles.secH}>
          Course <span className={styles.g}>outline.</span>
        </h2>
        <p className={styles.secSub}>
          Core sprints run back to back; the sixth ends with your capstone demo day. Optional
          modules are self-paced and included in the fee.
        </p>
        <div className={styles.tscroll}>
          <table>
            <tbody>
              <tr>
                <th>Block</th>
                <th>Module</th>
                <th>When</th>
                <th>Builds you ship</th>
                <th>Themes</th>
              </tr>
              {ROWS.map((row) => (
                <tr className={row.highlight ? styles.y : undefined} key={row.module}>
                  <td>
                    <b>{row.block}</b>
                  </td>
                  <td>{row.module}</td>
                  <td>{row.when}</td>
                  <td>{row.builds}</td>
                  <td>{row.themes}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default Outline;
